/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Copy_Id_Success_ToastInputs */



/**
* | output |
* | --- |
* | "ID copied to clipboard" |
*
* @param {Explorer_Info_Copy_Id_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_copy_id_success_toast = /** @type {((inputs?: Explorer_Info_Copy_Id_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Copy_Id_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID copie dans le presse-papiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("ID in die Zwischenablage kopiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID copiato negli appunti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор скопирован в буфер обмена")
	if (locale === "es") return /** @type {LocalizedString} */ ("ID copiado al portapapeles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ID已复制到剪贴板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("IDをクリップボードにコピーしました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आईडी क्लिपबोर्ड पर कॉपी हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID copiado para a área de transferência")
	return /** @type {LocalizedString} */ ("ID copied to clipboard")
});